const partnerFeatures = [
  {
    icon: 'ri-award-fill',
    title: 'Uncompromising Quality and Compliance',
  },
  {
    icon: 'ri-global-line',
    title: 'Vast Industry Network & Connections',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Comprehensive Education and Expert Support',
  },
];

export default function BecomePartner() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="py-24 px-6 relative"
      style={{
        background: 'linear-gradient(135deg, #7f1d1d 0%, #b91c1c 40%, #dc2626 100%)',
      }}
    >
      <div className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Become A Partner
        </h2>
        <p className="text-red-100 text-sm leading-relaxed max-w-3xl mx-auto mb-12">
          At OnPoint USA, we offer unparalleled expertise built over 10 years in the Regenerative Medicine field. We bring an extensive portfolio of high-quality products, personalized support, and ongoing education — along with a network of connections that opens doors throughout the industry. Our commitment to excellence, integrity, and customer satisfaction ensures you have everything needed to succeed in this rapidly evolving space.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {partnerFeatures.map((f) => (
            <div
              key={f.title}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 flex items-start gap-4 text-left hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
                <i className={`${f.icon} text-white text-lg`} />
              </div>
              <h3 className="text-white font-semibold text-sm leading-snug pt-2">{f.title}</h3>
            </div>
          ))}
        </div>

        <button
          onClick={() => handleNav('#contact')}
          className="mt-10 px-8 py-3.5 bg-white text-red-700 font-bold rounded-md hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
        >
          Contact Us Today
        </button>
      </div>
    </section>
  );
}
